import { IEnvironment } from './classes/IEnvironment';

export const environment: IEnvironment = {
  production: false,
  apiUrl: 'https://api.tantargyweb.sze.hu/api',
  authUrl: 'https://api.tantargyweb.sze.hu',
  emailAuthUrl: 'https://api.tantargyweb.sze.hu',
};